module.exports = __webpack_public_path__ + "static/power4-1@2x-b9f5a3f0b93553784d063165140fb75f.png";